import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PaymentHistoryComponent } from '../payment-history/payment-history.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-transcript-fee-process',
  templateUrl: './transcript-fee-process.component.html',
  styleUrls: ['./transcript-fee-process.component.scss']
})

export class TranscriptFeeProcessComponent implements OnInit {
  FeeForm: FormGroup;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  AdModeList: any;
  filteredAdModeList: any;
  SRList: any;
  filteredSR: any;
  totalAmount = 0;
  lvl: 0;
  zeroError = false;
  inputTimeout: any;
  arrTest: any = [];
  tabldata: any;
  selectedoption: any;
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  totalPayableAmount: number;
  totalPayAmount = 0;
  remainAmt = 0;
  StudentPersonalId;
  feeMode;
  tabldata2: any;
  ramt: number;
  Total = true;
  Message = false;
  due: number;
  RAmt
  submitButton = true;
  updateButton = false;
  feeApplyArray: FormArray;
  updateBtn = true;
  payHistoryBtn = false;
  disablePaid = true
  xyz: any;
  errMsg: any;
  payModeList: any;
  shouldShowErrorMessage: boolean = false;
  lastPaid: any;
  newPaid: any;
  filteredpayModeList: any;
  SnNo: any;
  filteredElements: any;
  FeeLevel: any;
  feeModeShow = true;
  ExamCurrency
  constructor(private fb: FormBuilder,
    public umsService: UmsService, public dialogRef1: MatDialogRef<TranscriptFeeProcessComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService, public router: Router,
    private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  FeeTable: any;
  tempCo = sessionStorage.getItem('TemplateCode');
  ngOnInit(): void {
    this.payHistoryBtn = false;
    this.getFeeTempData()
    this.updateBtn = true;
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    this.totalAmount = 0;
    this.totalPayAmount = 0;
    this.remainAmt = 0;
    this.Total = true;
    this.Message = false;
    this.ramt = 0;
    this.due = 0;
    this.lvl = 0;
 
    this.FeeForm = this.fb.group({
      TemplateName: new FormControl('', [Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
      StudentType: new FormControl('', []),
      StudentStatus: new FormControl(''),
      SocialReservation: new FormControl(''),
      TotalPaidAmount: new FormControl('', Validators.required),
      PayMode: new FormControl(''),
      feeHeadArray: new FormArray([]),
 
    });
    this.fetchPayMode();
  }
 
  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['FeeType'] = 'TC';
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.ExamCurrency = res.data[0].Currency
        // this.getRgId()
        this.getSecretData()
      } else {
        this.getSecretData()
        this.FeeLevel = null
      }
    });
  }
 
  getRgId() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        // this.searchExams(res.data[0]['RgId'])
        this.GetEcId(res.data[0]['RgId'])
      }
      else {
      }
    })
  }
 
  GetEcId(RgId){
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.getSecretData()
          // this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.getSecretData()
          // this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
 
      }
    });
  }
 
  searchExams(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {
      if (res.status) {
        if (res.data[0]['ChkRgId'] == '' || res.data[0]['ChkRgId'] == null) {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
        else {
          this.ExmFormSub(res.data[0]['EcId'], RgId)
        }
 
      }
    });
  }
 
  ExmFormSub(EcId, RgId) {
    this.filteredElements = []
    this.spinner.show();
    const payload = {};
    payload['EcId'] = EcId;
    payload['RgId'] = RgId;
    this.umsService.ExmFormSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.filteredElements = res.data.filter(element => {
          if (element.EsType == 'S' && (element.App == 'Y' || element.App == ' ')) {
            return element
          }
        });
        this.getSecretData()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
 
 
 
  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
      this.prepopulation(res.projectPharam['SnNo']);
    })
 
  }
 
  prepopulation(SnNo) {
    this.Total = true;
    this.Message = false;
    this.spinner.show();
    const payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = SnNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      let data = res.data[0];
      this.spinner.hide();
      if (res.status) {
        this.updateButton = true;
        this.submitButton =false;
        this.payHistoryBtn = true;
       this.tabldata2 = res.data;
        this.FeeForm = this.fb.group({
          TotalPaidAmount: new FormControl(''),
          PayMode: new FormControl(data.PayMode),
          feeHeadArray: new FormArray([]),
        });
        this.tabldata2 = res.data;
        this.lastPaid = data.TotalPaidAmount
        this.tabldata2.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              HeadName: new FormControl(element.Head),
              FeePaid: new FormControl(0),
              FeeDue: new FormControl(element.FeeDue),
              FeeDueDummy: new FormControl(element.FeeDue),
              FeeAmt: new FormControl(element.FeeAmount, [Validators.required, Validators.pattern('^[0-9]*$')]),
            })
          );
          this.FeeForm.controls['TotalPaidAmount'].setValue('');
          this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
            this.remainAmt = this.totalAmount - this.lastPaid
            this.totalPayAmount = this.totalAmount - this.remainAmt;
            this.ramt = this.remainAmt;
            if (this.remainAmt == 0) {
              this.payHistoryBtn = true
            }
            else {
              this.payHistoryBtn = false
            }
          if (this.remainAmt == 0) {
            this.updateBtn = true;
            this.Total = false;
            this.Message = true;
            this.payHistoryBtn = true
          } else {
            this.updateBtn = false;
            this.Total = true;
            this.Message = false;
            this.payHistoryBtn = false
          }
        });
      } else {
        this.spinner.show();
        const payload = {};
        payload['TemplateCode'] = this.tempCo;
        payload['FeeType'] = ''
        this.updateButton = false;
        this.submitButton = true;
        this.totalAmount =0
        this.umsService.getFeeTemplet(payload).subscribe((res) => {
          this.spinner.hide()
          let data = res.data[0];
          if (res.status) {
            this.tabldata = res.data;
            this.FeeForm = this.fb.group({
              TotalPaidAmount: new FormControl(''),
              PayMode: new FormControl(data.PayMode),
              feeHeadArray: new FormArray([]),
            });
            this.FeeTable = res.data;
            this.FeeTable.forEach((element, i) => {
              const creds = this.FeeForm.controls.feeHeadArray as FormArray;
              creds.push(
                this.fb.group({
                  FeeHead: new FormControl(element.FeeHead, [Validators.required]),
                  HeadName: new FormControl(element.Head),
                  FeePaid: new FormControl(0),
                  FeeDue: new FormControl(element.FeeAmount),
                  FeeDueDummy: new FormControl(element.FeeAmount),
                  FeeAmt: new FormControl(element.FeeAmount, [Validators.required, Validators.pattern('^[0-9]*$')]),
                })
              );
              this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
                this.remainAmt = this.totalAmount;
                this.totalPayAmount = this.totalAmount - this.remainAmt;
                this.ramt = this.remainAmt;
              
            });
 
 
          } else {
            // this.umsService.openSnackbar(res.message);
          }
        });
      }
    });
 
  }
 
 
 
  errorcheckP(i) {
    return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.pattern
  }

  errorcheckR(i) {
    return i.controls['FeePaid'].touched && i.controls['FeePaid'].errors?.required
 
  }
 
  getfeeHeadArrayControls() {
    return (this.FeeForm.get('feeHeadArray') as FormArray).controls;
  }
 
  close() {
    this.dialogRef1.close();
  }
 
  submitFeeTemplet() {
    if (this.FeeForm.invalid) {
      this.FeeForm.get('TotalPaidAmount').markAsTouched();
    }
    else {
      this.submit()
    }
  }
 
  submit() {
    this.spinner.show();
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
 
 
 
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(this.tempCo), //add neww
            StuId: new FormControl(this.StudentPersonalId),
            FeeType: new FormControl(this.data['CertType']),
            FeeHead: new FormControl(element.FeeHead),
            FeeStatus: new FormControl('Y'),
            FeeAmt: new FormControl(element.FeeAmt),
            FeePaid: new FormControl(element.FeePaid),
            FeeDue: new FormControl(element.FeeAmt),
            FeeDueDummy: new FormControl(element.FeeDue),
            FeePaymentMethod: new FormControl(this.feeMode),
            TotalPaidAmount: new FormControl(this.totalAmount),
            PayMode: new FormControl(this.submitpayload.PayMode),
            SnNo: new FormControl(this.SnNo),
            CreatedBy: new FormControl(''),
            TotalFeeAmount: new FormControl(this.totalAmount)
          })
        )
        this.umsService.addFeeTemplet(arr1[0].value).subscribe(res => {
          this.updateTC()
          // this.spinner.hide();
          const paymentDetails = {
            "amount": arr1[0].value.TotalPaidAmount,
            "StuId": this.StudentPersonalId,
            "FeeTemplateCode": this.tempCo,
            "FeeType": this.data['CertType'],
            "SnNo": this.SnNo.toString(),
            "firstname": arr1[0].value.FeeHead,
            "email": "jeeevishnu@gmail.com",
            "phone": "8296270993"
          }
          this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
            window.location.href = response.redirectUrl;
           
            // this.spinner.hide();
          });
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length -1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            // const paymentDetails = {
            //     "amount": arr1[0].value.TotalPaidAmount,
            //     "StuId" : this.StudentPersonalId,
            //     "FeeTemplateCode":this.tempCo,
            //     "FeeType": 'EF',
            //     "SnNo":this.SnNo,
            //     "firstname": arr1[0].value.FeeHead,
            //     "email": "jeeevishnu@gmail.com",
            //     "phone": "8296270993"
            //     }
            // this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
            //   window.location.href = response.redirectUrl;
 
            //   //  window.open(response.redirectUrl, '_blank');
            // });
           
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        // this.saveApplicationDetails();
        // this.updateTC()
       
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.dialogRef1.close();
        // });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
 
      }
    });
 
  }
  
  updateTC(){
    let payload = {}
    payload['StuFaculty'] = this.data['StuFaculty'],
    payload['StuCourse'] = this.data['StuCourse'],
    payload['StuCollege'] = this.data['StuCollege'],
    payload['StuExam'] = this.data['StuExam'],
    payload['StuBranch'] = this.data['StuBranch'],
    payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
    payload['CertType'] = this.data['CertType'],
    payload['DestClg'] = this.data['DestClg'],
    payload['Reason'] = this.data['Reason'],
    payload['FeeStatus'] = 'Y';
    payload['CertStatus'] = 'ReSubmitted';
    payload['StuId'] = this.data['StuId'],
    payload['TclcId'] = this.data['TclcId'],
    payload['Comment'] = '',
    payload['CertScr'] = '',
    payload['StatusBy'] = sessionStorage.getItem('loginId'),
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if(res.status){

        this.redirect('TC-LC-MC')
      }
    })
  }
 
 
  saveApplicationDetails() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    // this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SessionId'] = sessionStorage.getItem('session');
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['ApplicationName'] = 'Exam Fees'
    payload['ApplicationSubDate'] = formattedDate;
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
      } else {
        // this.spinner.hide()
      }
    })
  }
 
  amountCheck(index) {
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(index).get('FeeDue').value;
    this.FeeTable.forEach((element, i) => {
      if (element.FeeAmount < amountValue) {
        let data = {}
        data['message'] = "Payable Amount Should be Less than Or Equal to Due Amount"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
 
      }
    })
  }
 
  getAmount(event: any, i) {
 
  }
 
  onInputChange(val) {
    const tempData = val.target.value;
    this.updateBtn = true;
    if (tempData.charAt(0) === '0') {
      this.zeroError = true;
    }
    else if (tempData.charAt(0) !== '0') {
      this.zeroError = false;
    }
    if (tempData == '') {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    if (this.remainAmt == 0 && this.submitButton == true && this.lastPaid == undefined) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.totalAmount - tempData;
    }
 
    if (this.ramt < tempData || tempData > this.totalAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.ramt;
    }
    else if (tempData == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.newPaid = 0;
    }
    else {
      if (this.lastPaid == undefined && this.submitButton == true) {
        this.shouldShowErrorMessage = false;
        this.remainAmt = this.totalAmount - tempData;
        if (this.remainAmt == 0) {
          this.updateBtn = false
        } else {
          this.updateBtn = true
        }
      }
 
      this.shouldShowErrorMessage = false;
      this.remainAmt = this.ramt - tempData;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData);
      if (this.remainAmt == 0) {
        this.updateBtn = false
      } else {
        this.updateBtn = true
      }
    }
  }
 
 
  dueAmt(event, i) {
    let arrayData = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i);
    let amountValue = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeePaid').value;
    amountValue = parseInt(amountValue);
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    if (tempData[i]['FeePaid'] == '') {
      this.due = tempData[i]['FeeDueDummy'];
    }
    else {
      this.due = parseInt(tempData[i]['FeeDueDummy']) - parseInt(tempData[i]['FeePaid']);
    }
    this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
    this.feeApplyArray.at(i).get('FeeDue').setValue(this.due);
  }
 
  newFun(event, i) {
    let FeeDue1 = (<FormArray>this.FeeForm.get("feeHeadArray")).at(i).get('FeeDue').value;
    const tempData = this.FeeForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    let sumFeeDue = 0;
    tempData.forEach(element => {
      sumFeeDue += element.FeeDue;
    })
    this.remainAmt = sumFeeDue;
    this.totalPayAmount = this.totalAmount - this.remainAmt;
  }
 
  updateFeeTemplet() {
    if (this.FeeForm.invalid) {
      this.FeeForm.get('TotalPaidAmount').markAsTouched();
    }
    else {
      this.update()
    }
  }
 
  update() {
    this.zeroError = false;
    this.spinner.show();
    this.FeeForm.controls['TotalPaidAmount'].setValue(this.newPaid);
    this.submitpayload = this.FeeForm.value;
    let abcd = this.FeeForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            FeeTemplateCode: new FormControl(this.tempCo), //add neww
            StuId: new FormControl(this.StudentPersonalId),
            FeeType: new FormControl('TC'),
            FeeHead: new FormControl(element.FeeHead),
            FeeStatus: new FormControl('Y'),
            FeeAmt: new FormControl(element.FeeAmt),
            FeePaid: new FormControl(element.FeePaid),
            FeeDue: new FormControl(element.FeeAmt),
            FeeDueDummy: new FormControl(element.FeeDue),
            FeePaymentMethod: new FormControl(this.feeMode),
            TotalPaidAmount: new FormControl(this.totalAmount),
            PayMode: new FormControl(this.submitpayload.PayMode),
            SnNo: new FormControl(this.SnNo),
            CreatedBy: new FormControl(''),
            TotalFeeAmount: new FormControl(this.totalAmount)
          })
        )
        this.umsService.updateFeeTemplet(arr1[0].value).subscribe(res => {
 
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          // if (index === array.length -1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            const paymentDetails = {
              "amount": arr1[0].value.TotalPaidAmount,
              "StuId": this.StudentPersonalId,
              "FeeTemplateCode": this.tempCo,
              "FeeType": 'EF',
              "SnNo": this.SnNo,
              "firstname": arr1[0].value.FeeHead,
              "email": "jeeevishnu@gmail.com",
              "phone": "8296270993"
            }
            this.umsService.paymentgateway(paymentDetails).subscribe((response) => {
              window.open(response.redirectUrl, '_blank');
            });
          }
        },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          }
        );
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Update Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef1.close();
        });
      } else {
        this.zeroError = true
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
 
      }
    });
 
  }
 
 
  openHistoryPopup() {
    const dialogRef4 = this.dialog.open(PaymentHistoryComponent,
      {
        disableClose: true,
        width: "900px",
        height: "auto",
      });
    dialogRef4.afterClosed().subscribe((result) => {
 
    });
  }
 
  onInputChange2(val) {
    const tempData = val.target.value;
    if (tempData.TotalPaidAmount == '') {
      this.updateBtn = false;
      this.remainAmt = this.remainAmt;
    }
    if (this.remainAmt == 0 && this.submitButton == true) {
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if (this.remainAmt == 0 && this.updateButton == true) {
      this.remainAmt = 0
    }
    else if (this.remainAmt < tempData.TotalPaidAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if (tempData.TotalPaidAmount == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = 0;
    }
    else {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
 
    }
    if (tempData.TotalPaidAmount == this.totalAmount) {
      const Data = this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element, i) => {
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
      });
    }
  }

  isGreaterThanInput(): boolean {
    const tempData = this.FeeForm.value;
    const Data = this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount > this.totalAmount;
  }
 
  isSmallerThanInput(): boolean {
    const tempData = this.FeeForm.value;
    const Data = this.FeeForm.controls.feeHeadArray.value;
    return +tempData.TotalPaidAmount < this.totalAmount;
  }
 
 
  getAmount2() {
    // this.remainAmt = 0;
    const tempData = this.FeeForm.value;
    if (tempData.TotalPaidAmount == '') {
      this.updateBtn = false;
      this.remainAmt = this.remainAmt;
    }
    if (this.remainAmt == 0 && this.submitButton == true) {
      this.remainAmt = this.totalAmount - tempData.TotalPaidAmount;
    }
    else if (this.remainAmt == 0 && this.updateButton == true) {
      // this.remainAmt =  this.remainAmt - tempData.TotalPaidAmount;
      // this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
      this.remainAmt = 0
    }
    else if (this.remainAmt < tempData.TotalPaidAmount) {
      this.shouldShowErrorMessage = true;
      this.updateBtn = true;
      this.remainAmt = this.remainAmt;
    }
    else if (tempData.TotalPaidAmount == 0) {
      this.shouldShowErrorMessage = false;
      this.updateBtn = true;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = 0;
    }
    else {
      this.shouldShowErrorMessage = false;
      this.updateBtn = false;
      this.remainAmt = this.RAmt - tempData.TotalPaidAmount;
      this.newPaid = parseInt(this.lastPaid) + parseInt(tempData.TotalPaidAmount);
 
    }
    if (tempData.TotalPaidAmount == this.totalAmount) {
      const Data = this.FeeForm.controls.feeHeadArray.value;
      this.FeeTable = Data;
      this.FeeTable.forEach((element, i) => {
        this.feeApplyArray = this.FeeForm.get('feeHeadArray') as FormArray;
        this.feeApplyArray.at(i).get('FeePaid').setValue(element.FeeAmt);
      });
    }
  }
 
 
  fetchPayMode() {
    const payload = {};
    payload['CdType'] = 'PM';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.payModeList = res.data;
        this.filteredpayModeList = this.payModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

}